<style lang="less" scoped>
  .block-loading {
    position: absolute;
    top: 0; right: 0; bottom: 0; left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .mask {
    background-color: rgba(255, 255, 255, .35);
  }
</style>

<template>
  <div class="block-loading" :class="mask ? 'mask' : ''" v-if="loading">
    <van-loading color="#009999" />
  </div>
</template>

<script>
import { Loading } from 'vant'

export default {
  name: 'block-loading',
  components: {
    'van-loading': Loading
  },
  props: {
    loading: Boolean,
    mask: Boolean
  }
}
</script>
